export default {
  download: 'Download',
  play: 'Play',
  pause: 'Pause',
} as const;
